import { ErpSyncProviderEnum } from "@/core/features/app-info/erp-sync-provider.enum";

export class ErpSyncInfoDto {
  provider: ErpSyncProviderEnum;
}
